import { pickStringUnion, readString } from '@/lib/prop-utils';

export const IMAGE_BLOCK_FIT_VALUES = ['cover', 'contain'] as const;
export const IMAGE_BLOCK_ASPECT_VALUES = [
  'square',
  'portrait',
  'landscape',
  'wide',
  'ultrawide',
  'video',
  'auto',
] as const;

export type ImageBlockFit = (typeof IMAGE_BLOCK_FIT_VALUES)[number];
export type ImageBlockAspect = (typeof IMAGE_BLOCK_ASPECT_VALUES)[number];

export const IMAGE_ASPECT_OPTIONS: Array<{ value: ImageBlockAspect; label: string }> = [
  { value: 'auto', label: 'Original' },
  { value: 'portrait', label: 'Portrait' },
  { value: 'landscape', label: 'Landscape' },
];

export function selectedImageAspect(current: ImageBlockAspect | undefined): ImageBlockAspect {
  return IMAGE_ASPECT_OPTIONS.find((option) => option.value === current)?.value ?? 'auto';
}

const IMAGE_FIT_CLASSNAMES: Record<ImageBlockFit, string> = {
  cover: 'object-cover',
  contain: 'object-contain',
};

const IMAGE_ASPECT_CLASSNAMES: Record<ImageBlockAspect, string> = {
  square: 'aspect-square',
  portrait: 'aspect-[3/4]',
  landscape: 'aspect-[3/2]',
  wide: 'aspect-video',
  ultrawide: 'aspect-[3/1]',
  video: 'aspect-video',
  auto: 'h-full min-h-[180px]',
};

export function resolveImagePresentation({
  fit,
  aspect,
  isSvg = false,
  isCircle = false,
}: {
  fit?: unknown;
  aspect?: unknown;
  isSvg?: boolean;
  isCircle?: boolean;
}) {
  const requestedFit = pickStringUnion(readString(fit), IMAGE_BLOCK_FIT_VALUES, 'cover');
  const requestedAspect = pickStringUnion(readString(aspect), IMAGE_BLOCK_ASPECT_VALUES, 'wide');
  const resolvedFit = isCircle ? 'cover' : isSvg ? 'contain' : requestedFit;
  const resolvedAspect = isSvg && requestedAspect === 'auto' ? 'wide' : requestedAspect;

  return {
    requestedFit,
    requestedAspect,
    fit: resolvedFit,
    aspect: resolvedAspect,
    fitClassName: IMAGE_FIT_CLASSNAMES[resolvedFit],
    aspectClassName: IMAGE_ASPECT_CLASSNAMES[resolvedAspect],
  };
}
